import { render, staticRenderFns } from "./Warehouse.vue?vue&type=template&id=06590f2d&scoped=true&"
import script from "./Warehouse.vue?vue&type=script&lang=js&"
export * from "./Warehouse.vue?vue&type=script&lang=js&"
import style0 from "./Warehouse.vue?vue&type=style&index=0&id=06590f2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06590f2d",
  null
  
)

export default component.exports